import * as React from 'react';
import ReactSelect from 'react-select';
import { useFiltersContext } from '../../contexts/filters';

const Select = ({ taxonomy }) => {
    let options = taxonomy.terms.map((term) => {
        return {
            label: term.name,
            value: term.term_id,
        }
    })
    
    options = [
        { label: `All ${taxonomy.labels.name}`, value: '' },
        ...options
    ];

    const { selectedTax, selectTaxTerm } = useFiltersContext();
    const [ value, setValue ] = React.useState( options[0] );

    const prevValue = React.useRef( options[0].value )
    const handleOnChange = ( option ) => {
        if ( prevValue.current !== option.value ) {
            setValue( option );
            selectTaxTerm( taxonomy.name, option.value );

            prevValue.current = option.value;
        }
    }

    // When filters are reset, set our value back to the first option.
    React.useEffect(() => {
        if ( ! Object.values(selectedTax).length ) {
            setValue( options[0] );
        }
    }, [ selectedTax ])
    
    return (
        <ReactSelect 
            className="pfa-filter-select" 
            classNamePrefix="pfa-filter-select" 
            options={ options } 
            onChange={ handleOnChange }
            value={ value }
            key={ taxonomy.name }
        />
    )
}

Select.displayName = 'Select';

export default Select;